import { FC, useEffect, useMemo } from 'react';

import { sourcesConfigToTree } from 'utils/campaign';

import cpcFlexibleSourceButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/cpc_flexible_source_button_click';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';
import { useCampaignProcess } from 'utils/campaign/hooks/useCampaignProcess';

import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';
import { getCampaignType } from 'components/CpcFlexibleCreate/CpcForm/AdCampaignInformation/getCampaignType';
import { AllSources } from 'components/CpcFlexibleCreate/CpcForm/AdSources/AllSources/AllSources';
import { SourceItem } from 'components/CpcFlexibleCreate/CpcForm/AdSources/SourceItem/SourceItem';

import { selectMainMenuVacancyId } from 'store/models/mainMenu';
import { useDispatch, useSelector } from 'store/utils';

const TrlKeys = {
    label: 'AdCreate.AdForm.AdSources.legend',
};

export const AdSources: FC = () => {
    const { adSourcesConfig } = useSelector((state) => state.createCampaign);
    const vacancyId = useSelector(selectMainMenuVacancyId);
    const [isTouched, setIsTouchedOn] = useOnOffState(false);

    const { isCreateCampaign, isEditCampaign, isEditAdvertising } = useCampaignProcess();

    const trl = useTrls();
    const dispatch = useDispatch();

    const sourcesTree = useMemo(() => {
        return sourcesConfigToTree(adSourcesConfig);
    }, [adSourcesConfig]);

    const sendAdSourcesTouchEvent = () => {
        if (!isTouched && isCreateCampaign) {
            cpcFlexibleSourceButtonClick({ vacancyId });
            setIsTouchedOn();
        }
    };

    useEffect(() => {
        if (isEditCampaign) {
            void dispatch(getCampaignType());
        }
    }, [isEditCampaign, dispatch]);

    return (
        <MagritteFormField
            input={
                <>
                    <AllSources
                        isEditAdvertising={isEditAdvertising}
                        sendAdSourcesTouchEvent={sendAdSourcesTouchEvent}
                    />
                    {sourcesTree.map((source) => {
                        return (
                            <SourceItem
                                source={source}
                                key={source.apiSource}
                                isEditAdvertising={isEditAdvertising}
                                sendAdSourcesTouchEvent={sendAdSourcesTouchEvent}
                            />
                        );
                    })}
                </>
            }
            label={trl(TrlKeys.label)}
            vSpacingBottom={20}
        />
    );
};
